import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import ReactLink from '@client/components/reactLink/ReactLink';
import { selectFundraiser } from '@client/redux/fundraiser/fundraiserSelectors';
import { getIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import FundraiserCard from '@client/containers/fundraiserCard/FundraiserCard';
import MoreFromHlf from '@client/containers/moreFromHlf/MoreFromHlf';
import UrlPagination from '@client/components/paginations/urlPagination/UrlPagination';
import { getSearchParams } from '@client/shared/utils/urlUtils/urlUtils';
import {
  loadHomePageData,
  selectHomePageData,
} from '@client/pages/homePage/duckHomePage';
import { selectIsAuth0Authenticated } from '@client/redux/user/userReducer';
import EventCard from '@client/containers/eventCard/EventCard';
import { valueOrEmptyStr } from '@client/shared/utils/utils/utils';
import FeaturedCard from '@client/containers/featuredCard/FeaturedCard';
import SearchFundraisers from '@client/components/searchFundraisers/SearchFundraisers';
import { Hero } from '@client/components/hero/Hero';
import { RegisterSvg } from '../../components/icons/guideSvg/RegisterSvg';
import { EditSvg } from '../../components/icons/guideSvg/EditSvg';
import { ShareSvg } from '../../components/icons/guideSvg/ShareSvg';
import { CtaBlock } from '../../components/ctaBlock/CtaBlock';
import styles from './homePage.scss';

class HomePage extends PureComponent {
  static loadData(dispatch, urlLocation) {
    let searchParams = getSearchParams(urlLocation);

    if (!searchParams || !searchParams.includes('pageSize')) {
      searchParams = searchParams.includes('?')
        ? `${searchParams}&pageSize=6`
        : '?pageSize=6';
    }

    return dispatch(loadHomePageData(searchParams));
  }

  componentDidMount() {
    HomePage.loadData(this.props.dispatch, this.props.location);
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      const { dispatch, location } = this.props;

      if (prevProps.location.search !== location.search) {
        HomePage.loadData(dispatch, location);
      }
    }
  }

  isCallbackFromLogin = (location) => {
    return location.search.includes('code=');
  };

  render() {
    const { location, fundraiser, pageData, history } = this.props;
    const hero = getIn(pageData, 'hero');
    const ctaData = getIn(pageData, 'ctaBlock');
    const guide = getIn(pageData, 'guide', 'fields');
    const eventListingTitle = getIn(pageData, 'eventsListingTitle');
    const fundraiserListingTitle = getIn(
      pageData,
      'fundraiserListingTitle',
      'fields',
      'text'
    );
    const events = getIn(pageData, 'events');
    const topBarText = getIn(pageData, 'topBarText', 'fields', 'text');
    const topBarLink = getIn(pageData, 'topBarLink', 'fields');
    const topBarTextPart2 = getIn(
      pageData,
      'topBarTextPart2',
      'fields',
      'text'
    );

    const showTopBar = topBarText || topBarLink || topBarTextPart2;

    if (this.isCallbackFromLogin(location)) {
      return null;
    }

    return (
      <div className={`${styles.homeRoute}`}>
        <div className={`${styles.topBar}`}>
          {showTopBar && (
            <div
              className={`${styleHelper.contentContainer} ${styleHelper.titleSmPrimary} ${styles.topBarTitle}`}
            >
              {topBarText && `${topBarText} `}
              {topBarLink && (
                <ReactLink
                  className={`${styleHelper.titleSmPrimary} ${styles.topBarLink}`}
                  to={getIn(topBarLink, 'linkUrl')}
                >
                  {getIn(topBarLink, 'label')}
                </ReactLink>
              )}
              {topBarTextPart2 && ` ${topBarTextPart2}`}
            </div>
          )}
        </div>
        <Hero
          heading={getIn(hero, 'fields', 'heading')}
          description={getIn(hero, 'fields', 'description')}
          textCreateAccount={getIn(hero, 'fields', 'buttonCreateAccount')}
          textLogin={getIn(hero, 'fields', 'buttonLogin')}
          textCreateFundraiser={getIn(hero, 'fields', 'buttonCreateFundraiser')}
          imageMobile={getIn(hero, 'fields', 'imageMobile', 'fields')}
          imageDesktop={getIn(hero, 'fields', 'imageDesktop', 'fields')}
        />
        <div className={styleHelper.contentContainer}>
          <GuideHomePage data={guide} />
          {ctaData && <CtaBlock data={ctaData} />}
          {events && (
            <EventListing
              list={events}
              className={styles.eventsContainer}
              title={eventListingTitle}
            />
          )}
          <h2
            id={'listingSection'}
            className={`${styleHelper.titleMdPrimary} ${styles.fundraiserListingTitle} ${styleHelper.layoutMobileSidePadding}`}
          >
            {fundraiserListingTitle}
          </h2>
          <SearchFundraisers
            onSearchFundraiser={this.onSearchFundraiser}
            onSelectCategory={this.onSelectCategory}
            location={location}
            history={history}
          />
          <FundraiserListing
            className={styles.fundraiserListingProp}
            list={getIn(fundraiser, 'results')}
          />
          <UrlPagination
            className={styles.urlPaginationProp}
            pageCount={getIn(fundraiser, 'pageCount')}
          />
        </div>
        <MoreFromHlf />
      </div>
    );
  }
}

HomePage.propTypes = {
  dispatch: PropTypes.func,
  location: PropTypes.object,
  cookies: PropTypes.object,
  history: PropTypes.object,
  isAuth0Authenticated: PropTypes.bool,
  fundraiser: ImmutablePropTypes.map,
  pageData: ImmutablePropTypes.map,
};

function mapStateToProps(state) {
  return {
    fundraiser: selectFundraiser(state),
    pageData: selectHomePageData(state),
    isAuth0Authenticated: selectIsAuth0Authenticated(state),
  };
}

export default connect(mapStateToProps)(withCookies(HomePage));

const FundraiserListing = ({ className, list }) => (
  <div
    className={`${styleHelper.alignmentContainer}${
      className ? ` ${className}` : ''
    }`}
  >
    <div className={styleHelper.cardListGrid}>
      {list &&
        list.map((fundraiser) => {
          return (
            <FundraiserCard
              key={getIn(fundraiser, 'id')}
              fundraiser={fundraiser}
              showStatsInsteadOfDescription={true}
            />
          );
        })}
    </div>
  </div>
);

const EventListing = ({ className, list, title }) => {
  const isSingleEvent = list ? list.size === 1 : false;

  return (
    <div
      className={`${styleHelper.alignmentContainer} ${
        className ? ` ${className}` : ''
      }`}
    >
      {!isSingleEvent && (
        <h3 className={`${styleHelper.titleMdPrimary} ${styles.eventsTitle}`}>
          {valueOrEmptyStr(title)}
        </h3>
      )}
      <div className={`${styleHelper.grid13} ${styles.eventListing}`}>
        {list &&
          list.map((event) => {
            if (isSingleEvent) {
              const slug = getIn(event, 'fields', 'slug');
              const eventImageUrl = getIn(event, 'fields', 'eventImageUrl')
                ? getIn(event, 'fields', 'eventImageUrl')
                : getIn(event, 'fields', 'eventImage', 'fields', 'file', 'url');

              return (
                <FeaturedCard
                  title={title}
                  to={`/event/${slug}`}
                  subTitle={getIn(event, 'fields', 'eventSubTitle')}
                  imageUrl={eventImageUrl}
                  text={getIn(event, 'fields', 'eventShortDescriptionSummary')}
                  asterisk={false}
                  buttonLabel={'Ta mig dit'}
                  key={`featuredEvent:${slug}`}
                />
              );
            } else {
              return <EventCard data={event} key={`event:${index}`} />;
            }
          })}
      </div>
    </div>
  );
};

const GuideHomePage = ({ data }) => {
  return (
    <div
      className={`${styleHelper.alignmentContainer} ${styleHelper.layoutMobileSidePadding}`}
    >
      <div className={`${styleHelper.cardListGrid} ${styles.guideSection}`}>
        <div className={styleHelper.flexCol}>
          <div className={styles.guideIcon}>
            <RegisterSvg />
          </div>
          <h4 className={`${styles.title} ${styleHelper.titleMdPrimary}`}>
            {getIn(data, 'step1Header')}
          </h4>
          <p className={`${styles.text} ${styleHelper.breadTextPrimary}`}>
            {getIn(data, 'step1Text')}
          </p>
        </div>
        <div className={styleHelper.flexCol}>
          <div className={styles.guideIcon}>
            <EditSvg />
          </div>
          <h4 className={`${styles.title} ${styleHelper.titleMdPrimary}`}>
            {getIn(data, 'step2Header')}
          </h4>
          <p className={`${styles.text} ${styleHelper.breadTextPrimary}`}>
            {getIn(data, 'step2Text')}
          </p>
        </div>
        <div className={styleHelper.flexCol}>
          <div className={styles.guideIcon}>
            <ShareSvg />
          </div>
          <h4 className={`${styles.title} ${styleHelper.titleMdPrimary}`}>
            {getIn(data, 'step3Header')}
          </h4>
          <p className={`${styles.text} ${styleHelper.breadTextPrimary}`}>
            {getIn(data, 'step3Text')}
          </p>
        </div>
      </div>
    </div>
  );
};
